module.exports = __webpack_public_path__ + "static/media/react.793622e6.svg";